export default "__VITE_ASSET__3865e628__"